export default (year) => {
  const numYear = Number(year);
  const minYear = 1900;
  const date = new Date();
  const maxYear = date.getFullYear();
  if (numYear > minYear && numYear <= maxYear) return true;
  return false;
};
